<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="title">
			Contrats et supports
		</div>
		<div class="form-elem-container with-add">
			<label for="">type de contrat</label>
			<div class="start row">
				<custom-select :object="true" :getter="'full_name'" :items="contractTypeList" :solo="true" v-model="contractTypeToAdd"/>
				<div v-if="contractTypeToAdd && contractTypeToAdd.name !== 'Autre'" class="btn-plus" @click="addContract"><span class="icon-form-plus"></span></div>
			</div>
			<br/>
			<div class="add-support row start" v-if="contractTypeToAdd && contractTypeToAdd.name === 'Autre'">
				<div class="ctn-input ctn-label" v-inputUI>
					<label for="contract name">Nouveau contrat</label>
					<input type="text" name="contract name" v-model="newContract.name">
				</div>
				<div class="ctn-input ctn-label" v-inputUI>
					<label for="contract name">Numéro</label>
					<input type="text" name="contract name" v-model="newContract.number">
				</div>
				<div class="ctn-input ctn-label">
					<label for="type" class="active">Type</label>
					<custom-select :items="operationTypeList" v-model="newContract.type" />
				</div>

<!--				<div class="ctn-input ctn-label" v-inputUI>-->
<!--					<label for="contract type">Type</label>-->
<!--					<custom-select :items="operationTypeList" v-model="newContract.type"/>-->
<!--				</div>-->
				<div class="btn-plus" @click="addContractToContractList"><span class="icon-form-plus"></span></div>
			</div>
		</div>
		<div class="ctn-contracts">
			<div class="ctn-contract" v-for="(contract, key) in contracts" v-bind:key="key">
				<div class="ctn-top row">
					<div class="type">{{ contract.ref.full_name }}</div>
					<div class="btn-remove" @click="removeContract(key)" v-if="contract.supports.length === 0"><span class="icon-form-close"></span></div>
				</div>
				<div class="ctn-supports">
					<div class="form-elem-container with-add">
						<label for="">type de support</label>
						<div class="row start">
							<custom-select :items="supportListOfContract(contract.ref.contract_products)" :solo="true" :object="true" :getter="'product.full_name'" v-model="contract.supportToAdd"/>
							<div v-if="contract.supportToAdd.product.name !== 'Autre'" class="btn-plus" @click="addSupportToContract(key)"><span class="icon-form-plus"></span></div>
						</div>
					</div>
					<div class="add-support row start" v-if="contract.supportToAdd.product.name === 'Autre'">
						<div class="ctn-input ctn-label" v-inputUI :class="{ error: errors.has('nom du nouveau support') }">
							<label for="nom du nouveau support">Nouveau support</label>
							<input v-validate="'required'" type="text" name="nom du nouveau support" v-model="contract.newSupport.name">
						</div>
						<div class="ctn-input ctn-label" v-inputUI>
							<label for="isin">ISIN</label>
							<input type="text" name="isin" v-model="contract.newSupport.isin">
						</div>
						<div class="btn-plus" @click="addToSupportlistOfContract(key)"><span class="icon-form-plus"></span></div>
					</div>
					<div class="error-add-support error-message" v-if="contract.supportToAdd.product.name === 'Autre'">
						{{ errors.first('nom du nouveau support') }}
					</div>
					<div class="label">
						Supports associés
					</div>
					<div class="ctn-support row start" v-for="(support, keyt) in contracts[key].supports">
						<div class="name">{{ support.ref.full_name }}</div>
						<div class="duo-value row">
							<label class="row" for="value">Contrat N°</label>
							<input type="text" name="contract" v-model="support.contractNumber">
						</div>
						<div class="duo-value row">
							<label class="row" for="value">Pourcentage</label>
							<input type="number" min="0" max="100" step="0.01" name="percent" v-model="support.percent">
						</div>
						<div class="tri-value row">
							<label class="row" for="value">Prix unitaire</label>
							<input type="text" name="value" v-model="support.price">
							<custom-select :items="currencyList" v-model="support.currency"/>
						</div>
						<div class="duo-value row">
							<label class="row" for="value">Parts</label>
							<input type="text" name="value" v-model="support.part">
						</div>
						<div class="tri-value row">
							<label class="row" for="value">Montant investi</label>
							<input type="text" name="value" v-model="support.amountInvested">
							<custom-select :items="currencyList" v-model="support.currency"/>
						</div>
						<div v-if="!support.isAPI" class="btn small btn-gold" @click="addProductToMission(contract, support)">Ajouter</div>
						<div v-if="!support.isAPI" class="btn small btn-gold" @click="cancelProductFromMission(contract, support)">Annuler</div>
						<div v-if="support.isAPI" class="btn small btn-gold" @click="editProductFromMission(contract, support)">Editer</div>
						<div v-if="support.isAPI" class="btn small btn-gold" @click="removeProductFromMission(contract, support)">Supprimer</div>
					</div>
					<div class="no-support" v-if="contracts[key].supports.length === 0">
						Aucun support associé
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import { mapGetters } from 'vuex'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'

export default {
	name: 'EditContractsAndSupports',
	components: {
		CustomSelect
	},
	data () {
		return {
			operationTypeList: ['Financier', 'Tangible', 'International'],
			currencyList: Currency,
			operation: null,
			contracts: [],
			contractTypeToAdd: null,
			newContract: {
				name: null,
				number: null,
				type: null
			}
		}
	},
	mounted () {
		this.operation = this.$store.getters.operation(this.$route.params.id)
		this.operation.mission_contract_products.forEach((product) => {
			this.resolveProduct(product)
		})
	},
	methods: {
		addContract () {
			if (this.contractTypeToAdd !== 'Autre') {
				this.contracts.push({
					ref: this.contractTypeToAdd,
					supportToAdd: this.supportListOfContract(this.contractTypeToAdd.contract_products)[0],
					newSupport: {
						name: null,
						isin: null
					},
					supports: []
				})
			}
		},
		addContractToContractList () {
			if (this.newContract.name.trim() !== '') {
				this.$store.dispatch('addContract', this.newContract).then(() => {
					this.newContract = { name: null, type: null, number: null }
					this.contractTypeToAdd = this.contractTypeList[this.contractTypeList.length - 2]
				})
			}
		},
		supportListOfContract (list) {
			return list.concat([{ product: { name: 'Autre', full_name: 'Autre' } }])
		},
		addToSupportlistOfContract (contractKey) {
			this.$validator.validate().then((validation) => {
				if (validation) {
					const contract = this.contracts[contractKey]
					const support = contract.newSupport
					const id = contract.ref.id
					this.$store.dispatch('addProduct', {
						product: support,
						contractId: id
					}).then(() => {
						contract.newSupport = { name: null, isin: null }
						const supportList = this.supportListOfContract(contract.ref.contract_products)
						contract.supportToAdd = supportList[supportList.length - 2]
					})
				}
			})
		},
		addSupportToContract (key) {
			this.contracts[key].supports.push({
				ref: this.contracts[key].supportToAdd.product,
				price: 0,
				currency: 'EUR',
				part: 0,
				percent: 0,
				amountInvested: 0,
				contractNumber: this.contracts[key].ref.number,
				isAPI: false
			})
		},
		addProductToMission (contract, support) {
			this.$store.dispatch('addProductToMission', {
				mission_id: this.operation.id,
				contract_id: contract.ref.id,
				product_id: support.ref.id,
				amount: support.price,
				currency: support.currency,
				shares: support.part,
				percent: support.percent,
				amountInvested: support.amountInvested,
				contractNumber: support.contractNumber
			}).then((product) => {
				this.resolveProduct(product)
				this.cancelProductFromMission(contract, support)
			})
		},
		cancelProductFromMission (contract, support) {
			contract.supports.splice(contract.supports.indexOf(support), 1)
		},
		removeProductFromMission (contract, support) {
			this.$store.dispatch('removeProductFromMission', {
				operationId: this.operation.id,
				contract: contract,
				product: support
			}).then(() => {
				contract.supports.splice(contract.supports.indexOf(support), 1)
			}).catch((error) => {
				console.log(error)
			})
		},
		editProductFromMission (contract, support) {
			this.$store.dispatch('editProductFromMission', {
				operationId: this.operation.id,
				product: {
					id: support.id,
					mission_id: this.operation.id,
					contract_id: contract.ref.id,
					product_id: support.ref.id,
					amount: support.price,
					currency: support.currency,
					shares: support.part,
					percent: support.percent,
					amountInvested: support.amountInvested,
					contractNumber: support.contractNumber
				}
			})
		},
		resolveProduct (product) {
			// Resolve Contract
			const isContract = this.contracts.filter(contract => contract.ref.id === product.contract.id).length !== 0
			let contract = (isContract) ? this.contracts.filter(contract => contract.ref.id === product.contract.id)[0] : null
			if (!isContract) {
				// We need to add the contract
				contract = {
					ref: product.contract,
					supportToAdd: this.supportListOfContract(product.contract.contract_products)[0],
					newSupport: {
						name: null,
						isin: null
					},
					supports: []
				}
				this.contracts.push(contract)
			}

			// Add Support
			contract.supports.push({
				id: product.id,
				ref: product.product,
				price: product.amount,
				currency: product.currency,
				part: product.shares,
				percent: product.percent,
				amountInvested: product.amount_invested,
				contractNumber: product.contract_number,
				isAPI: true
			})
		},
		removeContract (key) {
			this.contracts.splice(key, 1)
		}
	},
	watch: {
		contractTypeList () {
			this.contractTypeToAdd = this.contractTypeList[0]
		}
	},
	computed: {
		...mapGetters({
			rawContractTypeList: 'getContractTypeList'
		}),
		contractTypeList () {
			return this.rawContractTypeList.concat([{ name: 'Autre', full_name: 'Autre' }])
		}
	}
}
</script>

<style lang="css" scoped>
.form-ui {
	max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// ContractsAndSupports.vue?4e4a107a